// extracted by mini-css-extract-plugin
export var active = "_2b-7";
export var backButton = "_2b-6";
export var clone = "_2b-c";
export var collapseBar = "_2b-h";
export var collapseMode = "_2b-j";
export var dragHandle = "_2b-a";
export var dropdownIcon = "_2b-e";
export var hidden = "_2b-p";
export var iconContainer = "_2b-m";
export var iconSwapper = "_2b-o";
export var navItem = "_2b-4";
export var navItemIcon = "_2b-d";
export var navProfile = "_2b-5";
export var notificationCountBadge = "_2b-g";
export var notificationDot = "_2b-n";
export var optionsContainer = "_2b-f";
export var primaryNav = "_2b-0";
export var primaryTab = "_2b-k";
export var secondaryNav = "_2b-1";
export var selected = "_2b-l";
export var settingsNav = "_2b-2";
export var settingsNavItems = "_2b-3";
export var show = "_2b-b";
export var sideNav = "_2b-i";
export var teamItem = "_2b-8";
export var userProfileItem = "_2b-9";